<app-flyout *ngIf="actionsFlyoutSettings"
            [settings]="actionsFlyoutSettings"
            (onSelect)="onSelect($event)">
</app-flyout>

<form [formGroup]="form" [hidden]="true">
  <app-upload-file #fileUpload
                   (change)="onFileChanged()"
                   [appMaxFileSizeValidator]="1"
                   formControlName="file"
                   maxUnitType="GB"
                   accept=".pcap,.pcapng,.gz"
                   id="upload-file-input">
  </app-upload-file>
</form>

<div class="g-grid-page__buttons__separator"></div>

<app-ui-button [variant]="'secondary'" [size]="'small'" [label]="texts.settings.env_config.pcap_player.actions.upload"
               [isLoadingState]="isGridActionRunning$ | async" (clicked)="openUploadDialog()">
</app-ui-button>

<app-export-button [filename]="texts.settings.env_config.pcap_player.title"
                   [gridSubject]="exportCsv$">
</app-export-button>

